export const LEFT_MENU_SEEKER = [
	{
		title: {
			en: 'My Preferences',
			hi: 'मेरी प्राथमिकताएं',
			de: 'Meine Präferenzen',
			es: 'Mis preferencias',
			tr: 'Tercihlerim',
		},
		tabKey: 'my-preferences',
		redirectTo: '/seeker/job-preference',
		icon: 'ri-filter-line',
	},
	{
		title: {
			en: 'Jobs',
			hi: 'नौकरियां',
			de: 'Stellenangebote',
			es: 'Ofertas de empleo',
			tr: 'İşler',
		},
		tabKey: 'job-search',
		redirectTo: '/job-search',
		icon: 'ri-file-search-line',
	},
	{
		title: {
			en: 'Suggested Jobs',
			hi: 'सुझाए गए नौकरियां',
			de: 'Vorgeschlagene Jobs',
			es: 'Trabajos sugeridos',
			tr: 'Önerilen İşler',
		},
		tabKey: 'suggested-jobs',
		redirectTo: '/seeker/suggested-jobs',
		icon: 'ri-file-search-line',
	},
	{
		title: {
			en: 'Popular Jobs',
			hi: 'लोकप्रिय नौकरियाँ',
			de: 'Beliebte Jobs',
			es: 'Empleos populares',
			tr: 'Popüler İşler',
		},
		tabKey: 'popular-jobs',
		redirectTo: '/seeker/popular-jobs',
		icon: 'ri-file-search-line',
	},
	{
		title: {
			en: 'Resume Builder',
			hi: 'रिज़्यूमे बिल्डर',
			de: 'Lebenslauf-Generator',
			es: 'Constructor de currículum',
			tr: 'Özgeçmiş Oluşturucu',
		},
		tabKey: 'resume-builder',
		redirectTo: '/seeker/resume-templates',
		icon: 'ri-article-line',
	},
	{
		title: {
			en: 'Scheduled Meetings',
			hi: 'निर्धारित बैठकें',
			de: 'Geplante Besprechungen',
			es: 'Reuniones programadas',
			tr: 'Planlanmış Toplantılar',
		},
		tabKey: 'scheduled-meetings',
		icon: 'ri-calendar-check-line',
		redirectTo: '/seeker/scheduled-meetings',
	},
	{
		title: {
			en: 'Applied Jobs',
			hi: 'आवेदित नौकरियां',
			de: 'Beworbene Jobs',
			es: 'Trabajos aplicados',
			tr: 'Başvurulan İşler',
		},
		tabKey: 'applied-jobs',
		redirectTo: '/seeker/applied-jobs',
		icon: 'ri-briefcase-line',
	},
	{
		title: {
			en: 'Saved Jobs Alerts',
			hi: 'सहेजे गए नौकरियों के अलर्ट',
			de: 'Gespeicherte Jobbenachrichtigungen',
			es: 'Alertas de trabajos guardados',
			tr: 'Kaydedilen İş Bildirimleri',
		},
		tabKey: 'saved-jobs-alerts',
		redirectTo: '/seeker/saved-jobs-alert',
		icon: 'ri-notification-4-line',
	},
	{
		title: {
			en: 'Saved Jobs',
			hi: 'सहेजे गए नौकरियां',
			de: 'Gespeicherte Jobs',
			es: 'Trabajos guardados',
			tr: 'Kaydedilen İşler',
		},
		tabKey: 'saved-jobs',
		redirectTo: '/seeker/favourite-jobs',
		icon: 'ri-star-line',
	},
	{
		title: {
			en: 'My Posts',
			hi: 'मेरी पोस्ट्स',
			de: 'Meine Beiträge',
			es: 'Mis publicaciones',
			tr: 'Gönderilerim',
		},
		tabKey: 'my-posts',
		redirectTo: '/my-feeds',
		icon: 'ri-add-box-line',
	},
	{
		title: {
			en: 'Current Plan History',
			hi: 'वर्तमान योजना इतिहास',
			de: 'Aktuelle Planverlauf',
			es: 'Historial de Plan Actual',
			tr: 'Geçerli Plan Geçmişi',
		},
		tabKey: 'current-plan-history',
		redirectTo: '/current-plan-history',
		icon: 'ri-price-tag-line',
	},
	{
		title: {
			en: 'Connection Management',
			hi: 'कनेक्शन प्रबंधन',
			de: 'Verwaltung von Verbindungen',
			es: 'Gestión de conexiones',
			tr: 'Bağlantı Yönetimi',
		},
		tabKey: 'connection-management',
		children: [
			{
				title: {
					en: 'My Connections',
					hi: 'मेरे कनेक्शन्स',
					de: 'Meine Verbindungen',
					es: 'Mis conexiones',
					tr: 'Bağlantılarım',
				},
				tabKey: 'my-connections',
				redirectTo: '/seeker/my-connections?activeTab=connected&value=',
			},
			{
				title: {
					en: 'Followings',
					hi: 'अनुसरण कर रहे हैं',
					de: 'Folgende',
					es: 'Siguiendo',
					tr: 'Takip Ettiklerim',
				},
				tabKey: 'followings',
				redirectTo: '/seeker/followings-list',
			},
			{
				title: {
					en: 'Blocked Users',
					hi: 'अवरोधित उपयोगकर्ता',
					de: 'Blockierte Benutzer',
					es: 'Usuarios bloqueados',
					tr: 'Engellenen Kullanıcılar',
				},
				tabKey: 'blocked-users',
				redirectTo: '/seeker/my-connections?activeTab=blockedusers&value=',
			},
		],
	},
	{
		title: {
			en: 'Account Settings',
			hi: 'खाता सेटिंग्स',
			de: 'Kontoeinstellungen',
			es: 'Configuraciones de cuenta',
			tr: 'Hesap Ayarları',
		},
		tabKey: 'account-settings',
		children: [
			{
				title: {
					en: 'Change Password',
					hi: 'पासवर्ड बदलें',
					de: 'Passwort ändern',
					es: 'Cambiar contraseña',
					tr: 'Şifre Değiştir',
				},
				tabKey: 'change-password',
				redirectTo: '/change-password',
			},
			{
				title: {
					en: '2 Factor Authentication',
					hi: '2 कारक प्रमाणीकरण',
					de: '2-Faktor-Authentifizierung',
					es: 'Autenticación de 2 factores',
					tr: '2 Faktörlü Kimlik Doğrulama',
				},
				tabKey: 'auth2Factor',
				type: 'toggle',
				modal: 'twoFactorAuthentication',
			},
			{
				title: {
					en: 'Deactivate Account',
					hi: 'खाता निष्क्रिय करें',
					de: 'Konto deaktivieren',
					es: 'Desactivar cuenta',
					tr: 'Hesabı Devre Dışı Bırak',
				},
				tabKey: 'deactivate-account',
				type: 'toggle',
				modal: 'deleteModal',
			},
			{
				title: {
					en: 'Delete Account',
					hi: 'खाता हटाएं',
					de: 'Konto löschen',
					es: 'Eliminar cuenta',
					tr: 'Hesabı Sil',
				},
				tabKey: 'delete-account',
				type: 'toggle',
				modal: 'deleteModal',
			},
		],
	},
];

export const LEFT_MENU_COMPANY = [
	{
		title: {
			en: 'Saved Talent',
			hi: 'सहेजे गए प्रतिभा',
			de: 'Gespeicherte Talente',
			es: 'Talento guardado',
			tr: 'Kaydedilen Yetenekler',
		},
		tabKey: 'saved-talent',
		icon: 'ri-filter-line',
		redirectTo: '/company/saved-talent',
	},
	{
		title: {
			en: 'Scheduled Meetings',
			hi: 'निर्धारित बैठकें',
			de: 'Geplante Besprechungen',
			es: 'Reuniones programadas',
			tr: 'Planlanmış Toplantılar',
		},
		tabKey: 'scheduled-meetings',
		icon: 'ri-calendar-check-line',
		redirectTo: '/company/scheduled-meetings',
	},
	{
		title: {
			en: 'My Jobs',
			hi: 'नौकरियां',
			de: 'Jobs',
			es: 'Puestos de trabajo',
			tr: 'İş İlanları',
		},
		tabKey: 'my-jobs',
		redirectTo: '/company/my-jobs',
		icon: 'ri-user-settings-line',
	},
	{
		title: {
			en: 'Inactive Jobs',
			hi: 'निष्क्रिय नौकरियां',
			de: 'Inaktive Jobs',
			es: 'Trabajos inactivos',
			tr: 'Pasif İşler',
		},
		tabKey: 'inactive-jobs',
		icon: 'ri-notification-4-line',
		redirectTo: '/company/inactive-jobs',
	},
	{
		title: {
			en: 'Advertisement / History',
			hi: 'विज्ञापन / इतिहास',
			de: 'Werbung / Geschichte',
			es: 'Publicidad / Historia',
			tr: 'Reklam / Geçmiş',
		},
		tabKey: 'advertisement',
		icon: 'ri-notification-4-line',
		redirectTo: '/company/advertisement',
	},
	{
		title: {
			en: 'My Posts',
			hi: 'मेरी पोस्ट्स',
			de: 'Meine Beiträge',
			es: 'Mis publicaciones',
			tr: 'Gönderilerim',
		},
		tabKey: 'my-posts',
		redirectTo: '/my-feeds',
		icon: 'ri-add-box-line',
	},
	{
		title: {
			en: 'Current Plan History',
			hi: 'वर्तमान योजना इतिहास',
			de: 'Aktuelle Planverlauf',
			es: 'Historial de Plan Actual',
			tr: 'Geçerli Plan Geçmişi',
		},
		tabKey: 'current-plan-history',
		redirectTo: '/current-plan-history',
		icon: 'ri-price-tag-line',
	},
	{
		title: {
			en: 'Connection Management',
			hi: 'कनेक्शन प्रबंधन',
			de: 'Verwaltung von Verbindungen',
			es: 'Gestión de conexiones',
			tr: 'Bağlantı Yönetimi',
		},
		tabKey: 'connection-management',
		children: [
			{
				title: {
					en: 'Followers/Employees',
					hi: 'अनुयायी / कर्मचारी',
					de: 'Anhänger/Mitarbeiter',
					es: 'Seguidores/Empleados',
					tr: 'Takipçiler/Çalışanlar',
				},
				tabKey: 'my-followers',
				redirectTo: '/company/followers-list?activeTab=followers&value=',
			},
			{
				title: {
					en: 'Followings/Blocked Profiles',
					hi: 'अनुसरण / अवरोधित प्रोफाइल्स',
					de: 'Folgende/Blockierte Profile',
					es: 'Seguidos/Perfiles bloqueados',
					tr: 'Takip Edilenler/Engellenen Profiller',
				},
				tabKey: 'my-followings',
				redirectTo: '/company/followings-list?activeTab=company&value=',
			},
		],
	},
	{
		title: {
			en: 'Account Settings',
			hi: 'खाता सेटिंग्स',
			de: 'Kontoeinstellungen',
			es: 'Configuraciones de cuenta',
			tr: 'Hesap Ayarları',
		},
		tabKey: 'account-settings',
		children: [
			{
				title: {
					en: 'Change Password',
					hi: 'पासवर्ड बदलें',
					de: 'Passwort ändern',
					es: 'Cambiar contraseña',
					tr: 'Şifre Değiştir',
				},
				tabKey: 'change-password',
				redirectTo: '/change-password',
			},
			{
				title: {
					en: '2 Factor Authentication',
					hi: '2 कारक प्रमाणीकरण',
					de: '2-Faktor-Authentifizierung',
					es: 'Autenticación de 2 factores',
					tr: '2 Faktörlü Kimlik Doğrulama',
				},
				tabKey: 'auth2Factor',
				type: 'toggle',
				modal: 'twoFactorAuthentication',
			},
			{
				title: {
					en: 'Deactivate Account',
					hi: 'खाता निष्क्रिय करें',
					de: 'Konto deaktivieren',
					es: 'Desactivar cuenta',
					tr: 'Hesabı Devre Dışı Bırak',
				},
				tabKey: 'deactivate-account',
				type: 'toggle',
				modal: 'deleteModal',
			},
			{
				title: {
					en: 'Delete Account',
					hi: 'खाता हटाएं',
					de: 'Konto löschen',
					es: 'Eliminar cuenta',
					tr: 'Hesabı Sil',
				},
				tabKey: 'delete-account',
				type: 'toggle',
				modal: 'deleteModal',
			},
		],
	},
];
